import { useId } from 'react';

import type { SedeSelectorProps } from '../types';

const ADD_VALUE = '__add__';

/**
 * Which campus the person is looking at. Always visible, even with one sede, with "Agregar otra
 * sede" at the end: every school is ready to grow (scoping 3.1).
 */
export const SedeSelector = ({ sedes, selectedId, onSelect, onAdd }: SedeSelectorProps) => {
  const id = useId();
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-xs font-medium text-gray-500">
        Sede
      </label>
      <select
        id={id}
        value={selectedId}
        onChange={(event) => {
          if (event.target.value === ADD_VALUE) {
            onAdd?.();
            return;
          }
          onSelect(event.target.value);
        }}
        className="rounded-control border border-gray-300 bg-white px-2 py-1.5 text-sm text-gray-800 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-100"
      >
        {sedes.map((sede) => (
          <option key={sede.id} value={sede.id}>
            {sede.name}
            {sede.isMain ? ' (principal)' : ''}
          </option>
        ))}
        {onAdd ? <option value={ADD_VALUE}>＋ Agregar otra sede</option> : null}
      </select>
    </div>
  );
};
